import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import IconButton from "@material-ui/core/IconButton";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Typography, InputLabel } from "@material-ui/core";
import { setStudentCategories } from "../firebaseApi";
const DEVMODE = true;
const styles = (theme) => ({});

function StudentCategories(props) {
	const [selectedValues, setSelectedValues] = React.useState(false);
	const [notFilled, setNotFilled] = React.useState(false);

	useEffect(() => {
		if (props.course && props.studentID) {
			
			try {
				setSelectedValues(props.course.students[props.studentID].studentCategories);
			} catch (e) {
				if (DEVMODE) {
					console.log(e);
				}
			}
		} else if (props.course) {
			setSelectedValues(props.studentCategories);
		}
	}, [props.course, props.open]);

	const handleChange = (category, event) => {
		setSelectedValues({
			...selectedValues,
			[category]: event.target.value,
		});
	};

	const handleSave = () => {

		if (
			Object.keys(selectedValues).length !== Object.keys(props.course.courseCategories).length &&
			props.course.chooseCategories
		) {
			setNotFilled(true);
		} else {
			
			if (props.studentID) {
				let data = {
					courseID: props.course.courseID,
					studentID: props.studentID,
					studentCategories: selectedValues,
				};

				setStudentCategories(data).then(() => {
					props.openCtl(false);
					setNotFilled(false);
					props.refreshCourseListen(props.course.courseID);
				});
			} else {
				props.updateStudentCategories(selectedValues);
				props.openCtl(false);
				setNotFilled(false);
			}
			
		}
	
		
	};

	const handleExit = () => {
		if (props.studentID) {
			if (
				Object.keys(props.course.students[props.studentID].studentCategories).length !==
					Object.keys(props.course.courseCategories).length &&
				props.course.chooseCategories
			) {
				setNotFilled(true);
			} else {
				props.openCtl(false);
				setNotFilled(false);
			}
		} else {
			if (
				Object.keys(props.studentCategories).length !==
					Object.keys(props.course.courseCategories).length &&
				props.course.chooseCategories
			) {
				setNotFilled(true);
			} else {
				props.openCtl(false);
				setNotFilled(false);
			}
		}
		
	};

	const handleClose = (event, reason) => {
		if (reason === "backdropClick") {
			return;
		}
		props.openCtl(false);
	};

	const isValidUrl = (url) => {
		try {
			new URL(url);
			return true;
		} catch (e) {
			return false;
		}
	};

	return (
		<>
			{selectedValues === false ? null : (
				<Dialog fullWidth maxWidth="sm" open={props.open} onClose={handleClose}>
					<DialogTitle>{"Course Categories for " + props.course?.courseName}</DialogTitle>

					<DialogContent>
						{props.course?.docLink && isValidUrl(props.course.docLink) && (
							<div style={{ paddingBottom: "20px" }}>
								<Typography>
									For more information on what these mean:
									<IconButton
										variant="outlined"
										color="primary"
										onClick={() => {
											window.open(props.course.docLink, "_blank");
										}}
									>
										<InfoOutlinedIcon />
									</IconButton>
								</Typography>
							</div>
						)}
						<div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
							{Object.entries(props.course.courseCategories)
								.sort(([categoryNameA], [categoryNameB]) => categoryNameA.localeCompare(categoryNameB))
								.map(([categoryName, items], index) => (
									<FormControl key={index} variant="outlined" fullWidth>
										<InputLabel>{categoryName}</InputLabel>
										<Select
											value={selectedValues[categoryName] || ""}
											onChange={(event) => handleChange(categoryName, event)}
											label={categoryName}
										>
											{items.map((item, itemIndex) => (
												<MenuItem key={itemIndex} value={item}>
													{item}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								))}
							{notFilled ? (
								<Typography style={{ color: "red" }}>Please fill all categories</Typography>
							) : null}
						</div>
					</DialogContent>

					<DialogActions>
						<Button color="primary" onClick={handleSave}>
							Save
						</Button>
						<Button color="primary" onClick={handleExit}>
							Cancel
						</Button>
					</DialogActions>
				</Dialog>
			)}
		</>
	);
}

const mapStateToProps = (state) => {
	return state;
};

const mapDispatchToProps = (dispatch) => {
	return {};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(withWidth()(StudentCategories))));
